import assetAliases from "../asset-aliases";

// lowercase alias -> canonical asset (first entry of its group)
const aliasMap = assetAliases.reduce((map, group) => {
    const canonical = group[0].toLowerCase();
    for (let alias of group) {
        map[alias.toLowerCase()] = canonical;
    }
    return map;
}, {});

// Normalizes an asset code so that equivalent tickers (e.g. TON and GRAM)
// compare equal. Comparison is case insensitive.
export const normalizeAsset = (asset) => {
    if (!asset) return asset;
    const lowered = asset.toLowerCase();
    return aliasMap[lowered] || lowered;
}

// Splits a 'BASE/QUOTE' symbol into its normalized base and quote assets.
export const splitSymbol = (symbol) => {
    const [base, quote] = (symbol || '').split('/');
    return [normalizeAsset(base), normalizeAsset(quote)];
}

// True when both codes are present and refer to the same underlying asset.
export const isSameAsset = (asset, otherAsset) => {
    if (!asset || !otherAsset) return false;
    return normalizeAsset(asset) === normalizeAsset(otherAsset);
}
